import React from "react";
import styled from "styled-components";
import { navigate } from "../../../services";

// import MergeIcon from './MergeIcon'
import PagesIcon from "./PagesIcon";
import SettingsIcon from "./SettingsIcon";
import BackIcon from "./BackIcon";

const WIDTH = 200;
const Container = styled.div`
    position: fixed;
    left: 50%;
    bottom: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: ${WIDTH}px;
    margin-left: ${-WIDTH / 2}px;

    & > svg,
    & > div {
        cursor: pointer;
        margin-left: 12px;
    }

    & > div:first-of-type {
        margin-right: 0;
    }

    & > svg:last-of-type {
        margin-left: 0;
    }
`;

type Props = {
    enableDarkTheme: boolean;
    doc_id: number;
    page_id: number;
    canAdminister: boolean;
};

export class Menu extends React.Component<Props> {
    onBackClick = () => navigate.to("/app/docs");

    render() {
        // const { readOnly } = this.props

        return (
            <Container>
                {/*{!readOnly && <MergeIcon {...this.props} />}*/}
                <PagesIcon {...this.props} />
                <SettingsIcon {...this.props} />
                <BackIcon {...this.props} onClick={this.onBackClick} />
            </Container>
        );
    }
}
